import React, { Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import routes from "./route.config";
import './App.css';
import '@chatui/core/dist/index.css';

declare global {
    var isMobile: boolean;
    var isPhone: boolean;
    var aiName: string;
    var apiBaseUrl: string;
    var apimKey: string;
    var welcomeMessage: string;
    var aiAskMessage: string;
}

export default function App(props: any) {
    var ua = navigator.userAgent;
    var os = (function () {
        var isWindowsPhone = /(?:Windows Phone)/.test(ua),
            isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
            isAndroid = /(?:Android)/.test(ua),
            isFireFox = /(?:Firefox)/.test(ua),
            isTablet =
                /(?:iPad|PlayBook)/.test(ua) ||
                (isAndroid && !/(?:Mobile)/.test(ua)) ||
                (isFireFox && /(?:Tablet)/.test(ua)),
            isPhone = /(?:iPhone)/.test(ua) && !isTablet,
            isWeChat = /(?:micromessenger)/.test(ua.toLocaleLowerCase()),
            isPc = !isPhone && !isAndroid && !isSymbian;

        return {
            isTablet: isTablet,
            isPhone: isPhone,
            isAndroid: isAndroid,
            isPc: isPc,
            isWeChat: isWeChat,
        };
    })();

    global.isMobile = os.isAndroid || os.isPhone;
    global.isPhone = os.isPhone;
    global.aiName = props.aiName;
    global.apiBaseUrl = props.apiBaseUrl;
    global.apimKey = props.apimKey;
    global.welcomeMessage = props.welcomeMessage;
    global.aiAskMessage = props.aiAskMessage;

    return (
        <div style={{ height: "100vh", overflow: `${global.isMobile ? "hidden" : ""}` }}>
            <BrowserRouter>
                <Suspense fallback={<></>}>
                    <Switch>
                        {routes.map((item, index) => {
                            return <Route
                                key={index}
                                exact={item.isExact}
                                path={item.path}
                                component={item.component}
                            />
                        })}
                    </Switch>
                </Suspense>
            </BrowserRouter>
        </div>
    );
}
